import "../../style/mobile/calendar/MCalendar.scss";
// import BigCalendar from './BigCalendar';
import MBigCalendar from "./MBigCalendar";
import MEvents from "./MEvent";

const MCalendar = () => {
  return (
    <div className="MCalendar">
      <MBigCalendar/>
      <MEvents />
    </div>
  );
};

export default MCalendar;